<script lang="ts" setup>
import { useRouter, useRoute } from 'vue-router'
import { DynamicForm } from '../../dynamic-form'
import { getForm } from '../../../core/services/forms'
import { onBeforeMount, ref } from 'vue'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { notificationError } from '@/app/core/util/notificationUtils'
import { DLoading } from 'front-library'
import { useI18n } from 'vue-i18n'
import {
  getCalculatePhase,
  createCalculatePhase,
  updateCalculatePhase
} from '../../../core/services/calculate-phases'
usePayrollChange(() =>
  Boolean(route.params.id) ? back() : window.location.reload()
)

/* router, notifications */
const notifications = useNotificationsStore()
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

/* Datos componente Loading */
const loading = ref(false)
const messageLoading = ref('')

/* Datos */
const customForm = ref<any>({})
const form = ref<typeof DynamicForm | null>(null)
let model: any = {}

const onSubmit = async (model: any) => {
  loading.value = true
  let saved = false
  try {
    if (!route.params.id) {
      saved = await createCalculatePhase(model)
    } else {
      saved = await updateCalculatePhase(model, `${route.params.id as string}`)
    }
    if (saved) {
      loading.value = false
      notifications.addNotification({
        title: !route.params.id
          ? t('notification.created')
          : t('notification.edited'),
        text: t('calculationPhases.notification.action', [
          !route.params.id
            ? t('notification.wasCreated')
            : t('notification.wasEdited')
        ]),
        type: 'success',
        time: 10000
      })
      void router.push({ name: 'ListCalculatePhases' })
    }
  } catch (error: any) {
    notificationError(error, 'calculationPhases', t, notifications, loading)
  }
}

const getEntity = async () => {
  if (!route.params.id) return
  model = await getCalculatePhase(route.params.id as string)
  if (model === undefined) {
    notifications.addNotification({
      title: t('notification.notFound'),
      text: t('calculationPhases.notification.error'),
      type: 'error',
      time: 10000
    })
    back()
  }
}

/* validar duplicados */
const onUpdateField = (field: any) => {
  const { iterativeConceptId, targetConceptId, activationConcepts } =
    form.value?.getModelsValues([
      'iterativeConceptId',
      'targetConceptId',
      'activationConcepts'
    ])
  if (
    field.name === 'iterativeConceptId' ||
    field.name === 'targetConceptId' ||
    field.name === 'activationConcepts'
  ) {
    const sameConceptsNotification = (text: string) => {
      notifications.addNotification({
        title: t('calculationPhases.notification.sameConcepts'),
        text: text,
        type: 'error',
        time: 10000
      })
    }
    const filterConceptActivationT = activationConcepts.filter((_: any) =>
      _.includes(targetConceptId)
    )
    const filterConceptActivationI = activationConcepts.filter((_: any) =>
      _.includes(iterativeConceptId)
    )
    if (
      filterConceptActivationI.length > 0 &&
      filterConceptActivationT.length > 0
    ) {
      sameConceptsNotification(
        t('calculationPhases.notification.sameIterateAndActivation')
      )
    } else if (filterConceptActivationI.length > 0) {
      sameConceptsNotification(
        t('calculationPhases.notification.sameIterateAndActivationError')
      )
    } else if (filterConceptActivationT.length > 0) {
      sameConceptsNotification(
        t('calculationPhases.notification.sameObjectiveAndActivationError')
      )
    } else if (targetConceptId === iterativeConceptId) {
      sameConceptsNotification(
        t('calculationPhases.notification.sameIterateAndObjectiveError')
      )
    }
  }
}

/* Volver */
const back = () => {
  void router.push({ name: 'ListCalculatePhases' })
}

onBeforeMount(async () => {
  loading.value = true
  try {
    await getEntity()
    customForm.value = await getForm({ entity: 'calculate-phases' })
    if (route.params.id !== undefined) messageLoading.value = t('loading.data')
    loading.value = false
  } catch (error: any) {
    if (error.response.status === 400) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: t('calculationPhases.notification.error'),
        type: 'error',
        time: 10000
      })
      back()
    } else {
      notificationError(error, 'calculationPhases', t, notifications, loading)
    }
  }
})
</script>
<template>
  <DLoading v-show="loading" :message="messageLoading" />
  <div class="h-full px-5">
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p
          class="text-3xl font-semibold text-shadow text-blue-900"
          v-html="
            route.params.id == undefined
              ? t('calculationPhases.create')
              : t('calculationPhases.edit')
          " />
      </div>
    </div>
    <DynamicForm
      ref="form"
      v-if="customForm?.tabs"
      :form-schema="customForm"
      :initial-model="model"
      :title-btn-save="
        route.params.id === undefined
          ? t('form.button.save')
          : t('form.button.update')
      "
      @cancel="back"
      @update-field="onUpdateField"
      @submit="onSubmit" />
  </div>
</template>
<style setup></style>
